import styled from "styled-components";

export const StudentList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 40px;
`;

export const StudentCard = styled.li`
  background: #f8f8f8;
  border: 1px solid #ccc;
  border-left: 6px solid #ffb800;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Name = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const Teacher = styled.p`
  font-size: 14px;
  color: #555;
  cursor: pointer;
  &:hover{
    opacity: 0.7;
  }
`;

export const Note = styled.p`
  font-size: 14px;
  font-style: italic;
  color: #777;
`;

export const UnpauseButton = styled.button`
  background: #4caf50;
  color: white;
  padding: 10px 16px;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: 0.3s;
  &:hover {
    background: #43a047;
  }
`;

export const LoadingText = styled.p`
  font-size: 16px;
  color: #888;
  margin-top: 40px;
  text-align: center;
`;
